import {
  FormDataPost,
  Get,
  getAPIUrl,
  Post,
} from "../../ApiServices/apiMethod";

export const UserEndPoints = {
  profile: "user/profile",
  updateProfile: "user/update-profile",
  addFundReq: "user/add-fund-request",
  addWithReq: "user/add-withdraw-request",
  getFundReq: "user/fund-requests",
  getWithdrawalReq: "user/withdraw-requests",
  walletBalance: "user/wallet-balance",
  fetchReferHistory: "user/fetch-refer-history",
  walletTxns: "user/wallet-transactions",
  settings: "user/setting",
  fetchTeamDetail: "user/fetch-team-details",
  userComission: "user/fetch-user-commission",

  paymetApi: "user/payment-upi",
  paymentStatus: "user/paymentStatus",

  OPTIONS_URL: "plinko/option-list",
  BETTING_URL: "plinko/betting"
};

export const getProfile = (param = "") => {
  const url = getAPIUrl(UserEndPoints.profile, param);
  return Get(url);
};
export const getWallletBalance = (param = "") => {
  const url = getAPIUrl(UserEndPoints.walletBalance, param);
  return Get(url);
};
export const updateProfile = (data, param = "") => {
  const url = getAPIUrl(UserEndPoints.updateProfile, param);
  return FormDataPost(url, data);
};

export const AddFundReq = (data, param = "") => {
  const url = getAPIUrl(UserEndPoints.addFundReq, param);
  return FormDataPost(url, data);
};

export const AddWithdrawalReq = (data, param = "") => {
  const url = getAPIUrl(UserEndPoints.addWithReq, param);
  return Post(url, data);
};

export const getFundReq = (param = "") => {
  const url = getAPIUrl(UserEndPoints.getFundReq, param);
  return Get(url);
};
export const getWithdrawalReq = (param = "") => {
  const url = getAPIUrl(UserEndPoints.getWithdrawalReq, param);
  return Get(url);
};

export const getReferHistory = (param = "") => {
  const url = getAPIUrl(UserEndPoints.fetchReferHistory, param);
  return Get(url);
};

export const getWalletTxns = (param = "") => {
  const url = getAPIUrl(UserEndPoints.walletTxns, param);
  return Get(url);
};

export const getWalletSettings = (param = "") => {
  const url = getAPIUrl(UserEndPoints.settings, param);
  return Get(url);
};

export const getTeamDetail = (param = "") => {
  const url = getAPIUrl(UserEndPoints.fetchTeamDetail, param);
  return Get(url);
};

export const getUserComission = (param = "") => {
  const url = getAPIUrl(UserEndPoints.userComission, param);
  return Get(url);
};

export const createPaymentApi = (data, param = "") => {
  const url = getAPIUrl(UserEndPoints.paymetApi, param);
  return Post(url, data);
};

export const checkPaymentstatus = (data, param = "") => {
  const url = getAPIUrl(UserEndPoints.paymentStatus, param);
  return Post(url, data);
};

export const getBetOptions = (param = "") => {
  const url = getAPIUrl(UserEndPoints.OPTIONS_URL, param);
  return Get(url);
};

export const bettingResult = (data, param = "") => {
  const url = getAPIUrl(UserEndPoints.BETTING_URL, param);
  return Post(url, data);
};

